import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]

  initialize() {
    Array.from(this.selectTarget.options).forEach(element => {
      if (element.dataset.default  === 'true') {
        element.selected = true
      }
    })
  }

  change() {
    const option = this.selectTarget.options[this.selectTarget.selectedIndex]

    option.selected = true
    Turbo.visit(option.value)
  }
}
